import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ResultModel } from "../models/response/base.model";
import { ApiService } from "./api.service";

const IMAGE_GALLERY_ROUTE = "image-gallery";

@Injectable()
export class ManageGalleryService {
  constructor(private apiService: ApiService) {}

  private withPermissionRoute(reqModel: any) {
    const payload = reqModel && typeof reqModel === "object" ? reqModel : {};
    if (!payload.Route) {
      payload.Route = IMAGE_GALLERY_ROUTE;
    }
    return payload;
  }

  getSingleImageGallery(reqModel): Observable<ResultModel> {
    const route = "/hotel/getSingleImageGallery";
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel));
  }
  getImageGalleryAdmin(reqModel): Observable<ResultModel> {
    const route = "/hotel/getImageGallery";
    return this.apiService.get<ResultModel>(route, this.withPermissionRoute(reqModel));
  }
  getImageGallery(reqModel): Observable<ResultModel> {
    const route = "/getImageGallery";
    return this.apiService.get<ResultModel>(route, reqModel);
  }
  addImageGallery(reqModel): Observable<ResultModel> {
    const route = "/hotel/addImageGallery";
    return this.apiService.post<ResultModel>(route, this.withPermissionRoute(reqModel));
  }

  updateImageGallery(reqModel): Observable<ResultModel> {
    const route = "/hotel/updateImageGallery";
    return this.apiService.post<ResultModel>(route, this.withPermissionRoute(reqModel));
  }

  deleteGalleryImage(reqModel): Observable<ResultModel> {
    const route = "/hotel/deleteGalleryImage";
    return this.apiService.delete<ResultModel>(route, this.withPermissionRoute(reqModel));
  }

  updateHomeGalleryStatus(reqModel): Observable<ResultModel> {
    const route = "/hotel/updateHomeGalleryStatus";
    return this.apiService.put<ResultModel>(route, reqModel);
  }
}
